import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motores',
  templateUrl: './motores.component.html',
  styleUrls: ['./motores.component.css']
})
export class MotoresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
